import { api } from '../api'
import type { Drill } from '@acepoker/contract'

export const duplicateDrill = async (drillId: Drill['id']): Promise<{ id: Drill['id'] }> =>
  await api().url(`/api/drill/${drillId}/duplicate`).post().json()
